export default "__VITE_ASSET__B2$woGs$__"